<footer class="bg-e-white overflow-hidden text-white">
  <div class="bg-e-dark-green px-6 md:pl-[100px]">
    <div class="py-10 flex flex-col md:py-[90px] xl:flex-row">
      <div class="flex w-full flex-col md:flex-row xl:w-2/3">
        @if(!!content){
          <div class="grid-cols-1 grid md:grid-cols-[repeat(3,_minmax(300px,_1fr))]" >
            @for (block of content.blocks; track $index) {
              <div class="mt-2.5 flex justify-center md:justify-start">
                @switch (block.component){
                  @case ('CTA') {<app-cms-button [button]="block"></app-cms-button>}
                  @case ('feedbackwidget') {<app-cms-feedbackwidget [feedbackwidget]="block" ></app-cms-feedbackwidget>   }
                }

              </div>
            }
          </div>
        }
      </div>
      <div class="mt-9 flex w-full flex-col md:flex-row md:justify-center md:items-center xl:mt-0 xl:w-1/3">
        <img src="/assets/images/bio.webp" alt="bio-logo" class="mx-auto max-h-24 max-w-24 xl:ml-15" loading="lazy" />
        <!-- <img src="/assets/images/b-corp-white.svg" alt="bcorp-logo" class="mx-auto max-h-24 max-w-24 xl:ml-5" loading="lazy" /> -->
      </div>
    </div>
  </div>

  <div class="px-6 py-10 flex flex-col items-center justify-between md:px-[100px] md:flex-row">

    <div class="py-[27px]">
      <img [src]="env.logo" width="137" alt="ekomenu logo" loading="lazy" />
      <span class="text-e-dark-green block text-center font-sans text-xs font-medium uppercase tracking-widest">{{ env.subtitle | translate }}</span>
    </div>

    <div class="text-e-dark-green flex flex-col items-center md:flex-row-reverse">
      <div class="flex flex-row">
        @for (social of socials; track social) {
          <a class="pr-[15px] mb-[50px] md:mb-0" title="{{ social.title }}" href="{{social.url}}" target="_blank">
            <img height="25" width="25" alt="{{social.title}}" src="{{social.src}}" loading="lazy" />
          </a>
        }
      </div>
      <p class="mr-[35px]">© {{ currentYear }}. All rights Reserved. </p>
    </div>
  </div>

</footer>
